import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@softline/core';
import {
  LogoutService,
  UserInfoService,
} from '@softline/auth';
import { CommonModule } from '@angular/common';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { SOFTLINE_FEATURE_APP_INFO, AppInfoStore, AppearanceService, navigateFn } from '@softline/application';
import { SoftAppsUserInfo } from '@softapps/core';

import { IconComponent } from '@softline/ui-core';
@Component({
  selector: 'soft-user-context-widget',
  templateUrl: './user-context-widget.component.html',
  styleUrls: ['./user-context-widget.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, CdkConnectedOverlay,
    IconComponent] })
export class UserContextWidgetComponent {
  private readonly navigate = navigateFn();
  private readonly store = inject(Store);
  private readonly logoutService = inject(LogoutService);
  private readonly appearanceService = inject(AppearanceService);
  protected readonly userInfo = inject<UserInfoService<SoftAppsUserInfo>>(UserInfoService);

  public readonly isDarkMode = computed(() => this.appearanceService.isDarkMode());

  public readonly appVersion = this.store.signal(
    SOFTLINE_FEATURE_APP_INFO,
    AppInfoStore.getters.version
  );
  public readonly appName = this.store.signal(
    SOFTLINE_FEATURE_APP_INFO,
    AppInfoStore.getters.name
  );
  public readonly authenticationContext = computed(() => this.userInfo.value());

  public readonly initials = computed(() => {
    const names = this.authenticationContext()?.userName?.split('.') ?? [];
    let initials = '';
    for (const name of names) {
      if (name.length > 0 && initials.length < 2) {
        initials += name.charAt(0).toUpperCase();
      }
    }
    return initials;
  });

  public isUserMenuOpen = false;

  public readonly logout = () => {
    this.isUserMenuOpen = false;
    this.logoutService.logout();
  };

  public readonly goToSettingsPage = () => {
    this.isUserMenuOpen = false;
    this.navigate(['/settings'], { origin: true });
  };

  public readonly toggleNightMode = () => {
    this.appearanceService.toggleDarkMode();
  };
}
